// Fonte: UManutContas.pas — Ds_Indice_Remun_Conta → consulta read-only
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { listarIndicesRemuneracaoConta } from '~/Services/Service';
import moment from 'moment';

var TabIndicesRemuneracao = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [loading, setLoading] = useState(false);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarIndicesRemuneracaoConta(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar índices de remuneração'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  return (
    <div className="contas-tab-content">
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Ativo</th>
              <th>Dt. Reavaliação</th>
              <th>ACDC Positivo</th>
              <th>ACDC Negativo</th>
              <th>Tipo Taxa</th>
              <th>Tipo Dias</th>
              <th>Período</th>
              <th>Dt. Início</th>
              <th>Dt. Últ. Processamento</th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={9} className="text-center text-muted">Nenhum índice de remuneração</td></tr>
            ) : (
              lista.map(function(item, i) {
                return (
                  <tr key={(item.ativo || '') + '_' + (item.data_reavaliacao || i)}>
                    <td>{item.ativo !== null && item.ativo !== undefined ? item.ativo : '-'}</td>
                    <td>{item.data_reavaliacao ? moment(item.data_reavaliacao).format('DD/MM/YYYY') : '-'}</td>
                    <td>{item.acdc_positivo !== null && item.acdc_positivo !== undefined ? item.acdc_positivo : '-'}</td>
                    <td>{item.acdc_negativo !== null && item.acdc_negativo !== undefined ? item.acdc_negativo : '-'}</td>
                    <td>{item.tipo_taxa || '-'}</td>
                    <td>{item.tipo_dias || '-'}</td>
                    <td>{item.periodo || '-'}</td>
                    <td>{item.data_inicio ? moment(item.data_inicio).format('DD/MM/YYYY') : '-'}</td>
                    <td>{item.data_ultimo_processamento ? moment(item.data_ultimo_processamento).format('DD/MM/YYYY') : '-'}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default TabIndicesRemuneracao;
